import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AmbienteService } from '../services/ambiente.service';
import { LoginService } from '../services/login.service';
import { Ambiente } from '../types/Ambiente.type';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent implements OnInit {
  items!: MenuItem[];
  ambientes: Ambiente[] = [];
  ambienteSelecionado!: Ambiente;
  nomeUsuario: String = "";

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public ambienteService: AmbienteService,
    private router: Router,
    private loginService: LoginService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.buscaAmbientes();

    this.nomeUsuario = localStorage.getItem('nomeUsuario') || ""

    this.items = [
      {
        label: 'Logout',
        command: () => {
          this.logout();
        },
      },
    ];
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['login']);
  }

  buscaAmbientes() {
    this.ambienteService.getMeusAmbientes().subscribe({
      next: (data) => {

        this.ambientes = data;

        if (localStorage.getItem('ambiente') == undefined) {
          if (this.ambientes.length !== 0) {
            this.ambienteSelecionado = this.ambientes[0];
            this.trocarAmbiente();
          }
        } else {
          this.ambienteSelecionado = JSON.parse(
            localStorage.getItem('ambiente') || ''
          );
        }
      },
      error: (err) => {
        if (err.status === 403) {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['login']);
        }
      },
    });
  }

  trocarAmbiente() {
    if (this.ambienteSelecionado)
      localStorage.setItem(
        'ambiente',
        JSON.stringify(this.ambienteSelecionado)
      );
    //location.reload();

    this.router.navigate([this.router.url]);

    // this.router.navigateByUrl(`/${this.router.url}`, {skipLocationChange: true}).then(() => {
    //     this.router.navigate([`/${this.router.url}`]).then(() => {
    //         console.log(`After navigation I am on:${this.router.url}`)
    //     })
    // })
  }
}
